import React from "react";
import PropTypes from "prop-types";
import {Model} from '@morningtrain/react-resources';
import AuthReaction from "../reactions/AuthReaction";
import ForgotPasswordLink from "./ForgotPasswordLink";
import {Checkbox, Input, Password} from "@morningtrain/react-fields";

function LoginForm(props) {

    const formContent = (React.Children.count(props.children) > 0) ? props.children : (
        <React.Fragment>
            <Input name={props.usernameFieldName} label={props.usernameFieldLabel} required={true} autoFocus={true}/>
            <Password name={props.passwordFieldName} label={props.passwordFieldLabel} required={true}/>
        </React.Fragment>
    );

    return (
        <Model namespace={props.namespace} resourceName={props.resourceName} submitoperationName={props.submitOperationName} operationName={props.operationName} submittable={true}>
            <AuthReaction/>

            <div className="form-content login">
                {formContent}
            </div>

            {props.beforeFooter}

            <div className="modal-footer login">
                <div className={'modal-footer-left'}>
                    <Checkbox name='remember' label={props.rememberMeLabel} className={'remember-me'} boxed={true}/>
                    <ForgotPasswordLink/>
                </div>
                <div className={'modal-footer-right'}>
                    <input type='submit' value={props.submitLabel}/>
                </div>
            </div>
        </Model>
    );
}

LoginForm.defaultProps = {
    namespace: 'auth',
    resourceName: 'login',
    submitOperationName: 'login',
    operationName: 'login',
    beforeFooter: null,
    usernameFieldName: 'username',
    usernameFieldLabel: 'Brugernavn',
    passwordFieldName: 'username',
    passwordFieldLabel: 'Brugernavn',
    submitLabel: 'Log ind',
    rememberMeLabel: 'Husk mig',
};

LoginForm.propTypes = {
    namespace: PropTypes.string,
    resourceName: PropTypes.string,
    submitOperationName: PropTypes.string,
    operationName: PropTypes.string,
    beforeFooter: PropTypes.node,
    usernameFieldName: PropTypes.string,
    usernameFieldLabel: PropTypes.node,
    passwordFieldName: PropTypes.string,
    passwordFieldLabel: PropTypes.node,
    submitLabel: PropTypes.string,
    rememberMeLabel: PropTypes.node,
};

export default LoginForm;
